// export const QRPageStyle = `
// @page {
//   size: A4;
//   margin:  0;
// }

// @media print {
//   html, body {
//     width: 210mm;
//     height: 297mm;
//     marginTop: 0;
//     padding: 0;
//   }
//   .print-preview {
//     display: block;
//   }

//   .print-preview > * {
//     /* Define styles for the printed content here */
//   }

//   /* Hide the main content */
//   body > * {
//     display: none !important;
//   }
//   * {
//     font-size: 20px;
//   }
// }
// `;
export const MnageUsersQRStyle = `
@page {
  size: A4;
  margin: 10px;
}

@media print {
  html {
    display: flex;
    flex-direction: column;
    justify-content: center;
 
    margin: 10px;
  }

  body {
    color: red;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
   
  }
}
`;

export const QRPageStyle = `
@page {
  size: A4;
  margin: 10px;
}

@media print {
  html {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
   
    width: 100vw;
    height: 100vh;
    margin: 10px;
  }

  body {
   
    color: red;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
   
  }
}
`;
export const apitable = `

  @page {
    size: landscape;
  }
  @media print {
    html {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
     
      width: 100vw;
      height: 100vh;
     
    }
  
    body {
     
      color: red;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
     
    }
  }
}`;

export const QuotePageStyle = `
@page {
  size: landscape;
  // margin: 10px;
}

@media print {
  html {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  }

  body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
`;

export const PopupPageStyle = `
@page {
  size: vertical;
  margin: 10px;
 
}

@media print {
  html, body {
    marginTop:20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .MuiBox-root, .MuiGrid-root {
    overflow: visible !important;
    height: auto !important;
  }

  .print-visible {
    display: block !important;
    visibility: visible !important;
  }

  * {
    font-size: 15px;
  }
}
`;
